import AccessView from './View';

export default AccessView;